import React, { useState } from 'react';
import { 
  ChevronDown, HelpCircle, MessageCircle, 
  Phone, Leaf, ArrowRight 
} from 'lucide-react';

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      category: "Leistungen & Ablauf",
      questions: [
        {
          q: "Bieten Sie Ihre Leistungen auch in der  an?",
          a: "Ja, wir sind sowohl in Deutschland als auch  tätig. Kontaktieren Sie uns gerne für ein individuelles Angebot in Ihrer Region."
        },
        {
          q: "Erhalte ich vorab ein Festpreisangebot?",
          a: "Selbstverständlich. Nach einer Vor-Ort-Beratung oder Projektanalyse erhalten Sie ein transparentes Angebot mit Festpreisgarantie."
        },
        {
          q: "Muss ich während der Arbeiten vor Ort sein?",
          a: "Nein. Sobald wir Zugang zum Grundstück haben, erledigt unser erfahrenes Team alle Arbeiten selbstständig und zuverlässig."
        }
      ]
    },
    {
      category: "Pflege & Qualität",
      questions: [
        {
          q: "Bieten Sie auch Wartungs- und Pflegeverträge an?",
          a: "Ja, wir bieten regelmäßige Pflegeverträge für Gärten, Grünanlagen und Außenbereiche – saisonal oder ganzjährig."
        },
        {
          q: "Arbeiten Sie nachhaltig?",
          a: "Wir setzen auf langlebige Materialien, moderne Maschinen und – wo möglich – umweltfreundliche Lösungen sowie regionale Pflanzen."
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white font-sans text-slate-800">
      
      {/* ================= HERO ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="/img/123.jpg" 
            alt="Garten Landschaftsbau" 
            className="w-full h-full object-cover animate-slow-zoom"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/70 to-transparent"></div>
        </div>

        <div className="relative z-10 max-w-[1600px] mx-auto text-center px-6">
          <div className="max-w-3xl space-y-6 animate-slide-up">
            
            <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight">
              Fragen? <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-200">
                Wir haben Antworten.
              </span>
            </h1>
            <p className="text-lg text-slate-200 max-w-xl">
              Alles Wissenswerte rund um unsere Leistungen im Garten- und Landschaftsbau.
            </p>
          </div>
        </div>
      </section>

      {/* ================= CONTENT ================= */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-[1600px] mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
            
            {/* CONTACT SIDEBAR */}
            <div className="lg:col-span-4 space-y-8">
              
              <div className="bg-white p-8 rounded-2xl shadow-xl border border-slate-100">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mb-6">
                  <MessageCircle className="text-emerald-600" size={24} />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Noch Fragen?</h3>
                <p className="text-slate-600 mb-6 text-sm leading-relaxed">
                  Schreiben Sie uns gerne eine E-Mail – wir melden uns schnellstmöglich bei Ihnen.
                </p>

                <a
                  href="mailto:info@palloshigalabau.de"
                  className="w-full bg-slate-900 text-white py-3 rounded-lg font-bold hover:bg-emerald-600 transition-all flex items-center justify-center gap-2"
                >
                  info@palloshigalabau.de
                  <ArrowRight size={18} />
                </a>
              </div>

              <div className="bg-emerald-900 p-8 rounded-2xl shadow-xl text-white relative overflow-hidden">
                <Leaf className="absolute -right-4 -bottom-4 text-white/10 w-32 h-32" />
                <h3 className="text-xl font-bold mb-4">Direkter Kontakt</h3>
                <p className="text-emerald-100/80 text-sm mb-6">
                  Rufen Sie uns an – wir beraten Sie gerne persönlich.
                </p>

                <a
                  href="tel:+4915735547097"
                  className="flex items-center gap-3 text-emerald-300 font-bold text-lg hover:text-white transition"
                >
                  <Phone size={20} />
                  +4915735547097
                </a>
              </div>

            </div>

            {/* FAQ ACCORDION */}
            <div className="lg:col-span-8 space-y-12">
              {faqData.map((category, catIdx) => (
                <div key={catIdx}>
                  <h2 className="text-sm font-bold uppercase tracking-widest text-emerald-600 mb-6">
                    {category.category}
                  </h2>

                  <div className="space-y-4">
                    {category.questions.map((item, qIdx) => {
                      const idx = `${catIdx}-${qIdx}`;
                      const isOpen = openIndex === idx;

                      return (
                        <div
                          key={qIdx}
                          className={`border rounded-xl overflow-hidden transition ${
                            isOpen
                              ? "bg-white border-emerald-200 shadow-lg"
                              : "bg-white/60 border-slate-200"
                          }`}
                        >
                          <button
                            onClick={() => toggleFAQ(idx)}
                            className="w-full px-6 py-5 flex justify-between items-center text-left"
                          >
                            <span className="font-bold text-lg text-slate-900">
                              {item.q}
                            </span>
                            <ChevronDown
                              className={`transition-transform ${
                                isOpen ? "rotate-180 text-emerald-600" : ""
                              }`}
                            />
                          </button>

                          {isOpen && (
                            <div className="px-6 pb-6 text-slate-600 leading-relaxed">
                              {item.a}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-slate-900 rounded-3xl p-12 flex flex-col md:flex-row justify-between items-center gap-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Bereit für Ihren perfekten Außenbereich?
              </h2>
              <p className="text-slate-400 text-lg">
                Palloshigalabau – Ihr Partner für Garten- & Landschaftsbau in Deutschland 
              </p>
            </div>

            <a
              href="mailto:info@palloshigalabau.de"
              className="bg-emerald-500 hover:bg-emerald-400 text-white px-10 py-4 rounded-xl font-bold text-lg flex items-center gap-2"
            >
              Jetzt anfragen <ArrowRight size={20} />
            </a>
          </div>
        </div>
      </section>

      <style>{`
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-slide-up {
          animation: slide-up 0.8s ease forwards;
        }
        @keyframes slow-zoom {
          from { transform: scale(1); }
          to { transform: scale(1.1); }
        }
        .animate-slow-zoom {
          animation: slow-zoom 20s linear infinite alternate;
        }
      `}</style>
    </div>
  );
};

export default FAQPage;
